export default __webpack_public_path__ + "static/media/Phone.69e1c277.svg";